import React, { ReactNode, FC } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/system';
import { colors, sizes } from 'src/themes/default';
import { useLocation } from 'react-router-dom';

type BodyContentPropsType = {
    noColor: boolean;
    noPadding: boolean;
};
const BodyContent = styled('div', {
    shouldForwardProp: (prop) => prop !== 'noColor' && prop !== 'noPadding',
})<BodyContentPropsType>(({ theme, noColor, noPadding }) => ({
    position: 'fixed',
    backgroundColor: noColor ? 'transparent' : colors.background_W,
    top: sizes.body_mobile_top,
    bottom: sizes.body_mobile_bottom,
    left: sizes.body_mobile_left,
    right: sizes.body_mobile_right,
    padding: noPadding ? 0 : sizes.body_mobile_PD,
    overflow: 'auto',

    [theme.breakpoints.up('sm')]: {
        top: sizes.body_top,
        bottom: sizes.body_bottom,
        left: sizes.body_left,
        right: sizes.body_right,
        padding: noPadding ? 0 : sizes.body_PD,
        overflow: 'auto',
    },
}));

type BodyPropsType = {
    draverWidth: number;
    children: ReactNode;
};
const BodyContainer: FC<BodyPropsType> = (props) => {
    const location = useLocation();
    const noColor = location.pathname.split('/')[1] === 'overview';
    const noPadding = location.pathname.split('/')[1] === 'overview';
    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3,
                width: { sm: `calc(100% - ${props.draverWidth}px)` },
            }}
        >
            <Toolbar />
            <BodyContent noColor={noColor} noPadding={noPadding}>
                {props.children}
            </BodyContent>
        </Box>
    );
};

export default BodyContainer;
